const init={
    userName:'',
    login:'false',
    email:'',
    taxYear:'',
    planId:'',
    planEid:'',
    token:'',
    role:'',
    documentName:'',
    serverUrl:'https://returndownload.api.intuit.com/return-download-service',
    updatedStatus:'',
    documentList:'dummy'
}

const rootReducer = (( state=init,  action ) =>{
    switch (action.type){
        case "UPDATE_NAME":
            return {
                userName:action.payload.name,
                login:action.payload.login,
                email:action.payload.email,
                taxYear:action.payload.year,
                planId:action.payload.planId,
                planEin:action.payload.planEin,
                token:action.payload.token,
                role:action.payload.role,
                documentName:action.payload.documentName,
                loginCount:action.payload.loginCount,
                taxReturnId:action.payload.taxReturnId,
                returnStatus:action.payload.returnStatus,
                realmId:action.payload.realmId,
                login:true,
                serverUrl:state.serverUrl,
                documentList:action.payload.document
            };
            break;

        case "CLEAR_NAME":
            return {userName:'', login:false, email:'', user_name:'',taxYear:'',planId:'',planEin:'',token:'',role:'',documentName:'',loginCount:'',taxReturnId:'',returnStatus:'',realmId:'',  serverUrl:state.serverUrl};
            break;

        case "UPDATE_STATE":
            return{
                userName:action.payload.userName,
                login:action.payload.login,
                email:action.payload.email,
                taxYear:action.payload.year,
                planId:action.payload.planId,
                planEin:action.payload.planEin,
                token:action.payload.token,
                role:action.payload.role,
                documentName:action.payload.documentName,
                loginCount:action.payload.loginCount,
                taxReturnId:action.payload.taxReturnId,
                returnStatus:action.payload.returnStatus,
                realmId:action.payload.realmId,
                login:true,
                serverUrl:state.serverUrl
            }
            break;

        case "SIGN_OUT":
            return {userName:'', login:false, email:'', user_name:'',taxYear:'',planId:'',planEin:'',token:'',role:'',documentName:'',loginCount:'',taxReturnId:'',returnStatus:'SIGNED',realmId:'',  serverUrl:state.serverUrl};
            break;

        default:
            return state;
    }
});

export default rootReducer;
